/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { styled } from '@mui/material';

import SelectedAccount from '../../../components/SelectedAccount/SelectedAccount';

const StyledSelectedAccount = styled(SelectedAccount)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'end',

  '&.fl-selected-account': {
    '.fl-selected-account__account-name': {
      fontSize: '1rem',
      lineHeight: '1.5rem',
      color: theme.colors.primary100,
    },

    '& > button.MuiButton-root': {
      lineHeight: '1rem',
    },
  },
}));

export default StyledSelectedAccount;
